export const getStores = () => {
  const stores = localStorage.getItem("multistore:stores");
  const data = JSON.parse(stores);

  return data;
};

export const getStoreInformations = () => {
  const store = localStorage.getItem("multistore:selectedStore");
  const data = JSON.parse(store);

  return data;
};
